<template>
  <div>
    <v-navigation-drawer
      fixed
      right
      :mini-variant.sync="mini"
      class="px-2 elevation-4"
      style="padding-top: 60px; top: 66px; height: calc(100vh - 66px);"
      width="400px"
      permanent
    >
      <v-toolbar
        elevation="4"
      >
        <v-btn
          icon
          @click="mini = !mini"
        >
          <v-icon v-if="!mini">
            mdi-arrow-right
          </v-icon>
          <v-icon v-if="mini">
            mdi-arrow-left
          </v-icon>
        </v-btn>
        <v-spacer />
        <span class="text-overline">Party Overview</span>
        <v-spacer />
        <v-btn
          icon
          color="primary"
          @click="editDialog = true"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-toolbar>
      <v-expansion-panels
        v-model="panel"
        accordion
        multiple
      >
        <PersonalOverviewSummary />
        <FamilyOverviewSummary />
        <BackgroundOverviewSummary />
        <HistoryOverviewSummary />
        <Notes />
      </v-expansion-panels>
    </v-navigation-drawer>
    <v-dialog
      v-model="editDialog"
      class="px-4 transparent elevation-0 overflow-hidden"
      max-width="1240px"
    >
      <v-card class="party-edit">
        <v-toolbar flat>
          <v-toolbar-title>
            Party Overview
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            color="primary"
            icon
            @click="onCloseDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-subtitle style="max-width: 800px;">
          To gather essential details about <strong>{{ partyFullName }}</strong>, kindly complete the card provided below. This information will assist in guiding you during the party interview process. To make edits, just click on the edit (
          <v-icon
            small
          >
            mdi-pencil
          </v-icon>
          ) icon on each card to unlock it and add the necessary information.
        </v-card-subtitle>
        <v-card-text>
          <PEOverview />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import BackgroundOverviewSummary from './SectionCards/OverviewCards/integrations/BackgroundOverviewSummary.vue'
import FamilyOverviewSummary from './SectionCards/OverviewCards/integrations/FamilyOverviewSummary.vue'
import HistoryOverviewSummary from './SectionCards/OverviewCards/integrations/HistoryOverviewSummary.vue'
import Notes from './SectionCards/OverviewCards/integrations/Notes.vue'
import PEOverview from './PEOverview'
import PersonalOverviewSummary from './SectionCards/OverviewCards/integrations/PersonalOverviewSummary.vue'

export default {
  name: 'PEOverviewSummary',

  components: {
    BackgroundOverviewSummary,
    FamilyOverviewSummary,
    HistoryOverviewSummary,
    Notes,
    PEOverview,
    PersonalOverviewSummary,
  },

  data () {
    return {
      editDialog: false,
      panel: [],
    }
  },

  computed: {
    mini: {
      get () {
        return this.peOverviewSummaryCollapsed
      },

      set (value) {
        this.setPeOverviewSummaryCollapsed(value)
      },
    },

    partyFullName () {
      const headerString = [this.peParty.first_name]
      if (this.peParty.middle_name) headerString.push(this.peParty.middle_name)
      headerString.push(this.peParty.last_name)

      return headerString.join(' ')
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peAnyUnlockedSections',
      'peOverviewSummaryCollapsed',
      'peParty',
    ]),
  },

  watch: {
    mini (collapsed) {
      this.panel = collapsed ? [] : [0, 1, 2, 3, 4]
    },
  },

  methods: {
    onCloseDialog () {
      if (this.peAnyUnlockedSections) {
        const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
        if (answer) {
          this.editDialog = false
        }
      } else {
        this.editDialog = false
      }
    },

    ...mapMutations(PARTY_NAMESPACE, [
      'setPeOverviewSummaryCollapsed',
    ]),
  },
}
</script>
